export default {
  subtitle: 'Cheile autentifică cererile către API-ul pentru parteneri. Trimite-le în header-ul x-api-key.',
  never_used: 'Niciodată folosită',
  revoke_confirm: 'Revoci această cheie? Cererile care o folosesc vor înceta imediat să funcționeze.',
  columns: {
    name: 'Nume',
    key: 'Cheie',
    status: 'Stare',
    last_used_at: 'Ultima utilizare',
    created_at: 'Creată',
  },
  statuses: {
    active: 'Activă',
    revoked: 'Revocată',
  },
  buttons: {
    create: 'Creează cheie',
    revoke: 'Revocă',
  },
  toasts: {
    load_error: 'Cheile API nu au putut fi încărcate.',
    error: 'Ceva nu a funcționat. Te rugăm să încerci din nou.',
    revoked: 'Cheie API revocată.',
  },
};
